import React, {Component} from 'react';
import { Panel } from "react-bootstrap";

import Spinner from '../../../Spinner';
import Table from "../../Table";

import 'react-select/dist/react-select.css';
import '../../../../assets/css/apiData.css';

import paymentMethods from "../../softwareIntegration/payment-methods";
import { toFormattedNumber } from "../../../../utils/utils.js";
import { DASHBOARD_DEPOSITS_PROCESSING_FEE } from '../../../../actions/types';
const store =  require('../../../../reducers/index');

class DashBoardDepositsProcessingFee extends Component {

  constructor(props) {
    super(props);

    this.state = {
      depositsFees: undefined,
      loading: true,
      socket: false,
      columns: [{
        value: "method",
        label: "Payment Method"
      }, {
        value: "currency",
        label: "Currency"
      }, {
        value: "topUp",
        label: "Top Up",
        isNumber: true
      }, {
        value: "deposits",
        label: "Deposits",
        rightAligned: true,
        isNumber: true
      }, {
        value: "rate",
        label: "Rate",
        rightAligned: true,
        isNumber: true
      }, {
        value: "processingFees",
        label: "Processing Fees",
        rightAligned: true,
        isNumber: true
      }]
    };
  }

  subscribeFunction = null;

  componentDidMount(){
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_DEPOSITS_PROCESSING_FEE && this.props.thisMonth && state.depositsFees.socket) {
        this.setState({ depositsFees: state.depositsFees, loading: false, socket: state.depositsFees.socket });
        return;
      }

      if (state.update === DASHBOARD_DEPOSITS_PROCESSING_FEE && !state.depositsFees.socket) {
        this.setState({ depositsFees: state.depositsFees, loading: false, socket: state.depositsFees.socket });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  tableData = () => {
    const { depositsFees } = this.state;

    if (!depositsFees) {
      return [];
    }

    return depositsFees.map(elem => {
      return {
        method: paymentMethods[elem.method],
        currency: elem.currency,
        deposits: toFormattedNumber(elem.deposits),
        rate: elem.rate + "%",
        topUp: elem.topUp,
        processingFees: toFormattedNumber(elem.processingFees)
      };
    });
  };

  render() {
    const { depositsFees, loading, columns } = this.state;

    let depositWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> DEPOSIT PROCESSING FEES </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && depositsFees) {
      depositWrap = (
        <Panel style={ { height: '100%' } }>
          <Panel.Heading>
            <Panel.Title> DEPOSIT PROCESSING FEES </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
                isStriped={ false }
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return depositWrap;
  }

}

export default DashBoardDepositsProcessingFee;